export default Object.freeze({
    /* 에러 코드 */
    SUCCESS: 0,                     // 성공
    SERVER_ERROR: -1001,            // 서버 에러
    REQUIRED_PARAM_ERROR: -1002,    // 필수 파라메터 에러
    LOGIN_ERROR: -1003,             // 로그인 실패
    API_RESULT_ERROR: -1004,        // API 통신 결과 에러
    CALL_STOP_ERROR: -1005,         // 콜 접수 중지

    /* 페이지 타입 */
    PAGE_TYPE_EDIT: 1,              // 에디터 페이지
    PAGE_TYPE_BOARD: 2,             // 게시판형태 페이지
    PAGE_TYPE_LINK: 3,              // 링크 페이지

    /* 주소 검색 API */
    ADDRESS_API_URL: "https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do",  // 도로명 주소 API URL
    ADDRESS_API_KEY: "U01TX0FVVEgyMDE4MTIxMzE2NTAwMzEwODM3NjU=",            // 도로명 주소 API KEY

    /* 콜접수 내역 조회 타입 */
    CALL_SEARCH_TYPE_ADDRESS: 1,    // 주소 리스트
    CALL_SEARCH_TYPE_CALLLIST: 2,   // 콜 리스트
    CALL_SEARCH_TYPE_HISTORY: 3,    // 이용내역

    /* 업로드 제한 용량 */
    MAX_UPLOAD_FILE_SIZE: 5242880   // 업로드 5MB 제한
});


// WEBPACK FOOTER //
// ./src/config/constants.js